function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5c13c03d\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../vue-loader/lib/selector?type=styles&index=0!./BrowserCheck.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./BrowserCheck.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5c13c03d\",\"hasScoped\":true}!../../../../vue-loader/lib/selector?type=template&index=0!./BrowserCheck.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c13c03d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/iexplore/components/browser/src/BrowserCheck.vue
// module id = 1076
// module chunks = 2